const navigation = {
  landing: '',
  login: '/login',
  home: '/home',
  loading: '/loading',
  schedule: '/schedule',
  usersSchedule: '/schedule/:id',
  worklog: '/worklog',
  usersWorklog: '/worklog/:id',
  techStack: '/admin-settings/tech-stack',
  dictionary: '/admin-settings/dictionary',
  accessibility: '/admin-settings/accessibility',
  general: '/admin-settings/general',
  users: '/users',
  newUser: '/users/new',
  projects: '/projects',
  newProject: '/new-project',
  projectDetails: '/projects/:id',
  user: '/users/:userId',
  reports: '/reports',
  candidates: '/candidates',
  candidateDetails: '/candidates/:id',
  newCandidate: '/candidates/new',
  profileBase: '/profile',
  myProfile: '/my-profile',
  userProfile: '/users/:id',
  settings: '/settings',
  projectsDistribution: '/projects-distribution',
  unauthorized: '/unauthorized',
  notFound: '*',
  adminPage: '/admin-page',
  adminSettings: '/admin-settings',
  vacation: '/vacations',
  yearlySummary: '/yearly-summary',
  usersYearlySummary: '/yearly-summary/:id',
  demands: '/demands',
  addDemand: '/demands/add-demand',
  editDemand: '/demands/:id',
  costSummary: '/cost-summary',
  settlements: '/settlements',
  leaderView: '/leader-view',
  addContract: '/users/:userId/contracts/new',
  editContract: '/users/:userId/contracts/:contractId/edit',
}

export default navigation
